var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 7.25C7.375 7.45711 7.20711 7.625 7 7.625C6.79289 7.625 6.625 7.45711 6.625 7.25C6.625 7.04289 6.79289 6.875 7 6.875C7.20711 6.875 7.375 7.04289 7.375 7.25Z",
    fill: "#D3E9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 11.75C11.875 11.9571 11.7071 12.125 11.5 12.125C11.2929 12.125 11.125 11.9571 11.125 11.75C11.125 11.5429 11.2929 11.375 11.5 11.375C11.7071 11.375 11.875 11.5429 11.875 11.75Z",
    fill: "#D3E9E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 17C13.3921 17 16.75 13.6421 16.75 9.5C16.75 5.35786 13.3921 2 9.25 2C5.10786 2 1.75 5.35786 1.75 9.5C1.75 13.6421 5.10786 17 9.25 17Z",
    fill: "#D3E9E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.25H7.0075M11.5 11.75H11.5075M12.25 6.5L6.25 12.5M7.375 7.25C7.375 7.45711 7.20711 7.625 7 7.625C6.79289 7.625 6.625 7.45711 6.625 7.25C6.625 7.04289 6.79289 6.875 7 6.875C7.20711 6.875 7.375 7.04289 7.375 7.25ZM11.875 11.75C11.875 11.9571 11.7071 12.125 11.5 12.125C11.2929 12.125 11.125 11.9571 11.125 11.75C11.125 11.5429 11.2929 11.375 11.5 11.375C11.7071 11.375 11.875 11.5429 11.875 11.75ZM16.75 9.5C16.75 13.6421 13.3921 17 9.25 17C5.10786 17 1.75 13.6421 1.75 9.5C1.75 5.35786 5.10786 2 9.25 2C13.3921 2 16.75 5.35786 16.75 9.5Z",
    stroke: "#24352F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageIcon);
export default __webpack_public_path__ + "static/media/percentage-icon.0cf89b60.svg";
export { ForwardRef as ReactComponent };